import { api } from './api';

/**
 * Tipo Pagamento interface
 */
export interface TipoPagamento {
  id: number;
  codice: string;
  nome: string;
  descrizione?: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Request interface for creating/updating a TipoPagamento
 */
export interface TipoPagamentoRequest {
  codice?: string;
  nome: string;
  descrizione?: string;
  isActive?: boolean;
}

/**
 * Get all TipiPagamento
 */
const getTipiPagamento = async (onlyActive = false): Promise<TipoPagamento[]> => {
  const url = onlyActive ? '/tipi-pagamento?onlyActive=true' : '/tipi-pagamento';
  const response = await api.get<TipoPagamento[]>(url);
  return response.data;
};

/**
 * Get a single TipoPagamento by ID
 */
const getTipoPagamentoById = async (id: number): Promise<TipoPagamento> => {
  const response = await api.get<TipoPagamento>(`/tipi-pagamento/${id}`);
  return response.data;
};

/**
 * Create a new TipoPagamento
 */
const createTipoPagamento = async (data: TipoPagamentoRequest): Promise<TipoPagamento> => {
  const response = await api.post<TipoPagamento>('/tipi-pagamento', data);
  return response.data;
};

/**
 * Update an existing TipoPagamento
 */
const updateTipoPagamento = async (id: number, data: TipoPagamentoRequest): Promise<TipoPagamento> => {
  const response = await api.put<TipoPagamento>(`/tipi-pagamento/${id}`, data);
  return response.data;
};

/**
 * Delete a TipoPagamento
 */
const deleteTipoPagamento = async (id: number): Promise<void> => {
  await api.delete(`/tipi-pagamento/${id}`);
};

const tipiPagamentoService = {
  getTipiPagamento,
  getTipoPagamentoById,
  createTipoPagamento,
  updateTipoPagamento,
  deleteTipoPagamento,
};

export default tipiPagamentoService;
